export default __webpack_public_path__ + "static/media/196744F7-534B-4D05-AA3E-F9FD06C41A38_1_105_c.9b82222c.jpeg";